<template>
  <div>
    <div v-if="orderInfo" class="price-wrapper">
      实付金额：<span class="price"
        ><span>￥</span>{{ orderInfo.actualPrice }}</span
      >
    </div>
    <div class="count-down">{{ countdownText }}</div>
  </div>
</template>

<script>
export default {
  name: 'PayTitle',
  props: ['orderInfo', 'payMethod'],
  computed: {
    countdownText() {
      if (this.payMethod === 7) {
        return '请在2分钟内完成支付，否则订单会自动关闭'
      }
      return '请在15分钟内完成支付，否则订单会自动关闭'
    }
  }
}
</script>

<style lang="scss" scoped>
.price-wrapper {
  font-size: 16px;
  color: #262626;

  .price {
    font-size: 28px;
    font-weight: bold;
    color: #e64c2e;

    span {
      font-size: 16px;
      font-weight: normal;
    }
  }
}

.count-down {
  padding: 20px 0 40px;
  font-size: 16px;
  color: #858585;
}
</style>
